import './polyfills';

import { type AvailableLocale } from '../language-provider/shared';
import enUSTranslationMessages from '../translations/compiled/en-US.json';

type LocaleTranslations = Record<string, string>;

export const DEFAULT_MESSAGES: LocaleTranslations = enUSTranslationMessages;

const loaded = new Map<AvailableLocale, LocaleTranslations>([
  ['en-US', DEFAULT_MESSAGES],
]);

/**
 * The compiled catalog for a shipped locale. Every catalog but English is its own
 * chunk, so a page downloads only the language it shows.
 */
export async function loadMessages(
  locale: AvailableLocale,
): Promise<LocaleTranslations> {
  const cached = loaded.get(locale);
  if (cached) return cached;
  const module = await import(`../translations/compiled/${locale}.json`);
  loaded.set(locale, module.default);
  return module.default;
}

/** A catalog `loadMessages` already resolved, so a render can use it at once. */
export function loadedMessages(
  locale: AvailableLocale,
): LocaleTranslations | undefined {
  return loaded.get(locale);
}
